export const DEVICES = [
    { value: 'desktop', label: 'ПК' },
    { value: 'ipad', label: 'Планшет', width: 768, height: 1024, description: 'iPad 9.7", Samsung Galaxy 9.7"' },
    { value: 'iphone', label: 'Телефон', width: 375, height: 667, description: 'iPhone 6/7/8, Samsung Galaxy S6/S7/S8' }
];
